import React from 'react';
import { useSelector } from 'react-redux';
import TotalLawsuitReports from './TotalLawsuitReports';
import FacilityLawsuitReports from './FacilityLawsuitReports';
import { SettingsSelectors } from '@store/slices/settings';
import LawsuitReportsGrid from './components/LawsuitReportsGrid';
import { UserSelectors } from '@store/slices/user';
import { SessionSelectors } from '@store/slices/session';
import { DashboardMode } from '@declarations/common/enums/DashboardMode';

function LawsuitReports() {
  const facility = useSelector(SettingsSelectors.selectedFacility);
  const user = useSelector(UserSelectors.user);
  const dashboardMode = useSelector(SessionSelectors.dashboardMode);
  if (user.expertRole && dashboardMode === DashboardMode.Expert) {
    return <LawsuitReportsGrid lawsuitsReportGridKey={'facility-lawsuits'} gridFilterItem={undefined}/>
  }
  return facility ? <FacilityLawsuitReports/> : <TotalLawsuitReports/>;
}

export default LawsuitReports;
